import { retrieveLaunchParams } from "@telegram-apps/bridge"
import { notificationTaps } from "../model/queue"

const START_PARAM_PATTERN = /^n_([1-9]\d{0,14})$/

export function readTelegramTap(): void {
	if (!window.location.hash.includes("tgWebApp")) return
	const startParam = currentStartParam()
	if (startParam === null) return
	const match = START_PARAM_PATTERN.exec(startParam)
	if (match === null) return

	notificationTaps.add({ notificationId: Number(match[1]), source: "telegram" })
}

function currentStartParam(): string | null {
	try {
		return retrieveLaunchParams().tgWebAppStartParam ?? null
	} catch {
		return null
	}
}
